export default "__VITE_ASSET__BTqjHfsm__"